import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Page } from '@containers/layout';
import { Box, IconButton } from '@components/common';
import { MoveoutDateRange, MoveoutProperty } from '@containers/moveout';
import MoveoutActions, {
  MOVEOUT_STAGE,
  MoveoutSelectors
} from '@redux/MoveoutRedux';
import history from '@utils/history';

const MobileFlex = styled(Box)`
  position: relative;
  display: flex;
  flex-direction: 'column';
  width: 100%;
  flex: 1;
  justify-content: center;
  align-items: center;

  @media screen and (min-width: 1024px) {
    flex-direction: column;
    justify-content: flex-start;
    padding-top: 48px;
  }

  @media screen and (max-width: 767px) {
    flex-direction: column;
    justify-content: center;
  }
`;

function MoveoutPage(props) {
  const { moveoutStep, goToStep, resetState } = props;

  const renderBackButton = () => {
    return (
      <IconButton
        onClick={goToPrevStep}
        name="back"
        width={16}
        height={16}
        title="Back"
      />
    );
  };

  const goToPrevStep = () => {
    switch (moveoutStep) {
      case MOVEOUT_STAGE.PROPERTY:
        goToStep(MOVEOUT_STAGE.DATE_RANGE);
        break;
      default:
        history.goBack();
    }
  };

  const goToNextStep = () => {
    switch (moveoutStep) {
      case MOVEOUT_STAGE.DATE_RANGE:
        goToStep(MOVEOUT_STAGE.PROPERTY);
        break;
      case MOVEOUT_STAGE.PROPERTY:
        resetState();
        history.push('/');
        break;
      default:
    }
  };

  const renderContent = () => {
    switch (moveoutStep) {
      case MOVEOUT_STAGE.DATE_RANGE:
        return (
          <MoveoutDateRange onSubmit={goToNextStep} onCancel={goToPrevStep} />
        );
      case MOVEOUT_STAGE.PROPERTY:
        return (
          <MoveoutProperty onSubmit={goToNextStep} onCancel={goToPrevStep} />
        );
    }
    return null;
  };

  return (
    <Page renderHeaderLeftButtons={renderBackButton} title="Moveout">
      <MobileFlex>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          flex={1}
          width={1}
        >
          {renderContent()}
        </Box>
      </MobileFlex>
    </Page>
  );
}

MoveoutPage.propTypes = {
  moveoutStep: PropTypes.string.isRequired,
  goToStep: PropTypes.func,
  resetState: PropTypes.func
};

const mapStatesToProps = state => ({
  moveoutStep: MoveoutSelectors.selectCurrentStep(state)
});

const mapDispatchToProps = dispatch => ({
  goToStep: step => dispatch(MoveoutActions.setMoveoutStep(step)),
  resetState: () => dispatch(MoveoutActions.setInitialState())
});

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(MoveoutPage);
